/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Fc_Online_Selfhost_S1Inputs */

const en_fc_online_selfhost_s1 = /** @type {(inputs: Fc_Online_Selfhost_S1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Download filmcraft-web-${i?.version}.zip from the official release and unzip it.`)
};

/**
* | output |
* | --- |
* | "Download filmcraft-web-{version}.zip from the official release and unzip it." |
*
* @param {Fc_Online_Selfhost_S1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_selfhost_s1 = /** @type {((inputs: Fc_Online_Selfhost_S1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Selfhost_S1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_selfhost_s1(inputs)
});
export { fc_online_selfhost_s1 as "fc.online.selfhost.s1" }